import React from 'react';
import NewsPageLayout from '../components/newsList/newsPageLayout';

class NewsPage extends React.Component {
	render() {
		return <NewsPageLayout></NewsPageLayout>;
	}
}

export default NewsPage;